import {
  useIsTokenListed,
  usePool,
  usePriceConverters,
} from '@trustpad/launchpad';

import dayjs from 'dayjs';

import { DateTimeFormat } from '~config/constants';
import { ListItem } from '~features/pools/components/PoolSecondaryBlock/InfoListItem';

export function ListingItem() {
  const {
    pool: {
      token: { listingInfo },
    },
  } = usePool();
  const { formatListingTime } = useIsTokenListed();

  return (
    <ListItem label="Token Listing">
      {formatListingTime()} <span className="text-sm">{listingInfo}</span>
    </ListItem>
  );
}
